import React, { useState } from "react";
import Layout from "../../component/layout";
import { getItem } from '../../../../utils/localStorage'
import { makeRequest2 } from '../../../../utils/makeRequest'
import { toastify } from '../../../../utils/toast'
import { searchPlatesURL } from '../../../../utils/urls'

const SearchPlates = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searched, setSearched] = useState(false);

    const handleSearchPlate = async () => {
        if (!searchTerm.trim()) {
            toastify("Please enter a plate number to search", "error");
            return;
        }

        setLoading(true);
        setSearched(true);

        try {
            const facilityId = await getItem("selectedFacilityId");

            const normalizedPlate = searchTerm.replace(/\s+/g, "").toUpperCase();

            const response = await makeRequest2(
                `${searchPlatesURL}/${facilityId}?plate=${encodeURIComponent(normalizedPlate)}`,
                "GET"
            );

            const responseData = response?.data;

            if (responseData && responseData.success) {
                const results = Array.isArray(responseData.data) ? responseData.data : [];
                setSearchResults(results);

                if (results.length === 0) {
                    toastify("No matching plates found", "info");
                } else {
                    toastify(`Found ${results.length} matching record(s)`, "success");
                }
            } else {
                const errorMessage = responseData?.error || response?.error || "Search failed";
                toastify(errorMessage, "error");
                setSearchResults([]);
            }
        } catch (error) {
            toastify("Error searching plates", "error");
            setSearchResults([]);
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearchPlate();
        }
    };

    const clearSearch = () => {
        setSearchTerm("");
        setSearchResults([]);
        setSearched(false);
    };

    return (
        <Layout>
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        <h5 className="mb-0">Search Vehicle Plates</h5>
                                        {searched && (
                                            <button
                                                className="btn btn-outline-secondary btn-sm"
                                                onClick={clearSearch}
                                            >
                                                Clear Search
                                            </button>
                                        )}
                                    </div>
                                    <div className='card-body'>
                                        <div className="row">
                                            <div className="col-lg-12 col-xxl-12">
                                                <div className="card">
                                                    <div className="card-body position-relative">
                                                        <div className="mb-4">
                                                            <h6 className="text-muted mb-3">Search Vehicle Registration Plates</h6>
                                                            <div className="row g-3 align-items-end">
                                                                <div className="col-md-6">
                                                                    <label htmlFor="plateInput" className="form-label">
                                                                        Number Plate <span className="text-danger">*</span>
                                                                    </label>
                                                                    <div className="input-group">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="plateInput"
                                                                            placeholder="e.g., KBC 2234, KBJ 2234"
                                                                            value={searchTerm}
                                                                            onChange={(e) => setSearchTerm(e.target.value.toUpperCase())}
                                                                            onKeyPress={handleKeyPress}
                                                                            disabled={loading}
                                                                        />
                                                                        {loading && (
                                                                            <span className="input-group-text">
                                                                                <div className="spinner-border spinner-border-sm" role="status">
                                                                                    <span className="visually-hidden">Loading...</span>
                                                                                </div>
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <div className="form-text">
                                                                        Enter plate number. Search is case-insensitive.
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <button
                                                                        className="btn btn-primary w-100"
                                                                        onClick={handleSearchPlate}
                                                                        disabled={loading || !searchTerm.trim()}
                                                                    >
                                                                        {loading ? (
                                                                            <>
                                                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                                                Searching...
                                                                            </>
                                                                        ) : (
                                                                            'Search Plate'
                                                                        )}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Search Results */}
                                                        {searched && (
                                                            <div className="mt-4">
                                                                <h6 className="text-muted mb-3">
                                                                    Search Results {searchResults.length > 0 && `(${searchResults.length} found)`}
                                                                </h6>

                                                                {searchResults.length === 0 ? (
                                                                    <div className="alert alert-info text-center">
                                                                        No vehicle plates found matching "<strong>{searchTerm}</strong>"
                                                                    </div>
                                                                ) : (
                                                                    <div className="table-responsive">
                                                                        <table className="table table-striped table-hover">
                                                                            <thead className="table-light">
                                                                                <tr>
                                                                                    <th>Plate Number</th>
                                                                                    <th>Visitor Name</th>
                                                                                    <th>Resident</th>
                                                                                    <th>House No.</th>
                                                                                    <th>Status</th>
                                                                                    <th>Entry Time</th>
                                                                                    <th>Entry Method</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {searchResults.map((log) => (
                                                                                    <tr key={log._id}>
                                                                                        <td>
                                                                                            <strong>
                                                                                                {log.vehicle?.registration || log.plateNumber || 'N/A'}
                                                                                            </strong>
                                                                                        </td>
                                                                                        <td>{log.visitorName}</td>
                                                                                        <td>{log.residentName}</td>
                                                                                        <td>{log.houseNumber}</td>
                                                                                        <td>
                                                                                            <span className={`badge ${log.status === 'Checked In' ? 'bg-success' :
                                                                                                log.status === 'Denied' ? 'bg-danger' :
                                                                                                    'bg-warning'
                                                                                                }`}>
                                                                                                {log.status}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td>
                                                                                            {new Date(log.startTime).toLocaleString()}
                                                                                        </td>
                                                                                        <td>
                                                                                            <span className={`badge ${log.entryMethod === 'DELIVERY' ? 'bg-info' :
                                                                                                log.entryMethod === 'ALLOWED BY GUARD' ? 'bg-primary' :
                                                                                                    'bg-secondary'
                                                                                                }`}>
                                                                                                {log.entryMethod}
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default SearchPlates;